var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"reason",class:_vm.reasonClass},[_vm._v(_vm._s(_vm.order.mys_reason))])
}
var staticRenderFns = []

export { render, staticRenderFns }